module.exports = __webpack_public_path__ + "static/media/medium1.bb0593a6.svg";